/**
 * Contact form delivery settings.
 *
 * The form is sent through Web3Forms (https://web3forms.com), which forwards
 * every submission to the mailbox this access key was created for.
 * Replace the key here if the receiving mailbox ever changes.
 */
export const WEB3FORMS_ACCESS_KEY = '4ab514e5-931a-487b-b464-3c6c616b9a53'
